// HELPER: SET COOKIE
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${JSON.stringify(cvalue)};${expires};path=/`;
}

// HELPER: Remove string from array
function removeA(arr) {
  let what;
  const a = arguments;
  let L = a.length;
  let ax;
  while (L > 1 && arr.length) {
    what = a[--L];
    while ((ax = arr.indexOf(what)) != -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
}

// HELPER: Get cookie value by name
function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

(($) => {
  $(() => {
    const cookieBanner = document.querySelector(".cookiebanner")
      ? document.querySelector(".cookiebanner")
      : null;
    // Bail if no banner element present.
    if (!cookieBanner) {
      return;
    }
    // Set Cookie value structure
    const consentValue = JSON.parse('{"Allow":[]}');
    const cbOverlay = document.querySelector(".cboverlay")
      ? document.querySelector(".cboverlay")
      : "";

    /**
     * Update checkbox values based on user clicks
     */
    if (document.getElementById("cookiebanner")) {
      document.getElementById("all").onclick = function () {
        if (!consentValue.Allow.includes("Analytics")) {
          consentValue.Allow.push("Analytics");
        }
        if (!consentValue.Allow.includes("Targeting")) {
          consentValue.Allow.push("Targeting");
        }

        setCookie("consent_cookie", consentValue, "365");
        setTimeout(() => {
          window.location.reload();
        }, 100);
      };

      document.getElementById("open_settings").onclick = function () {
        cbOverlay.classList.toggle("visible");
      };

      /**
       * Accept only necessary settings
       */
      document.getElementById("accept_only_necessary_settings").onclick =
        function () {
          if (consentValue.Allow.includes("Analytics")) {
            removeA(consentValue.Allow, "Analytics");
          }
          if (consentValue.Allow.includes("Targeting")) {
            removeA(consentValue.Allow, "Targeting");
          }

          setCookie("consent_cookie", consentValue, "365");
          setTimeout(() => {
            window.location.reload();
          }, 100);
        };
    }

    /**
     * Open Cookie Settings from footer link
     */
    const footerlink = document.querySelector(
      ".footer_cookie_consent_banner_link"
    );
    if (footerlink !== null) {
      document.querySelector(".footer_cookie_consent_banner_link").onclick =
        function () {
          cbOverlay.classList.toggle("visible");
        };
    }

    if (cookieBanner != "" && !getCookie("consent_cookie")) {
      cookieBanner.classList.remove("hidden");
    }
    /**
     * Set Cookie based on checkbox values
     */
    document.getElementById("save_settings").onclick = function () {
      const cbAnalytics = document.getElementById("cb_analytics").checked;
      const cbTargeting = document.getElementById("cb_targeting").checked;

      if (cbAnalytics && !consentValue.Allow.includes("Analytics")) {
        consentValue.Allow.push("Analytics");
      }
      if (!cbAnalytics && consentValue.Allow.includes("Analytics")) {
        removeA(consentValue.Allow, "Analytics");
      }

      if (cbTargeting && !consentValue.Allow.includes("Targeting")) {
        consentValue.Allow.push("Targeting");
      }
      if (!cbTargeting && consentValue.Allow.includes("Targeting")) {
        removeA(consentValue.Allow, "Targeting");
      }

      setCookie("consent_cookie", consentValue, "365");

      cbOverlay.classList.remove("visible");
      location.reload();
    };

    /**
     * Checkbox states based on cookie value
     */
    document.getElementById("cb_must_have").checked = true;
    document.getElementById("cb_must_have").disabled = true;

    if (getCookie("consent_cookie")) {
      const currentConsentState = JSON.parse(getCookie("consent_cookie"));
      let adStorage = "denied";
      let adUserData = "denied";
      let adPersonalization = "denied";
      let analyticsStorage = "denied";

      if (currentConsentState.Allow.includes("Targeting")) {
        document.getElementById("cb_targeting").checked = true;
        adStorage = "granted";
        adUserData = "granted";
        adPersonalization = "granted";
      }

      if (currentConsentState.Allow.includes("Analytics")) {
        document.getElementById("cb_analytics").checked = true;
        analyticsStorage = "granted";
      }

      // Update local storage and Google Tag consent based on the preferences
      window.dataLayer = window.dataLayer || [];
      localStorage.setItem("consentGranted", "true");
      function gtag() {
        dataLayer.push(arguments);
      }

      gtag("consent", "update", {
        ad_storage: adStorage,
        ad_user_data: adUserData,
        ad_personalization: adPersonalization,
        analytics_storage: analyticsStorage,
      });
    } else {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("consent", "default", {
        ad_user_data: "denied",
        ad_personalization: "denied",
        ad_storage: "denied",
        analytics_storage: "denied",
        wait_for_update: 500,
      });
      dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    }
  });
})(jQuery);
